export const LIST = "ROLE_LIST";
export const DETAILS = "ROLE_DETAILS";
export const UPDATE = "ROLE_UPDATE";
export const UPDATE_STATUS = "ROLE_UPDATE_STATUS";
export const STORE = "ROLE_STORE";